module.exports = __webpack_public_path__ + "img/2.63d78f27.jpg";